import { useState } from "react";
import { config } from "../../config";
import { toast } from "react-toastify";

const displayLabel = (value) => {
  const labels = { incity: "Incity", minioutstation: "Mini Outstation", outstation: "Outstation", oneway: "One Way", roundtrip: "Round Trip", hatchback: "Hatchback", sedan: "Sedan", suv: "SUV", luxury: "Luxury", manual: "Manual", auto: "Auto", ev: "EV" };
  return labels[String(value || "").toLowerCase()] || String(value || "-").replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const EditFareModal = ({ fare, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    ...fare,
    fares: {
      per12HoursCharge: fare?.fares?.per12HoursCharge || 0,
      perHourCharge: fare?.fares?.perHourCharge || 0,
      ...fare.fares,
    },
  });

  const [isUpdating, setIsUpdating] = useState(false);

  //  FIXED: correct condition
  const isOutstation = formData.tripSection === "outstation";

  const formatLabel = (key) => {
    const labelMap = {
      baseCharge: "Base Charge",
      perMinuteCharge: "Per Minute Charge",
      perHalfHourCharge: "Per Half Hour Charge",
      perHourCharge: "Per Hour Charge",
      per12HoursCharge: "Per 12 Hours Charge",
    };

    return labelMap[key] || key;
  };

  const round = (n) => Number(n.toFixed(2));

  const calculateTimeFares = (name, value) => {
    const num = Number(value);

    //  ONLY OUTSTATION SHOULD USE 12hr LOGIC
    if (isOutstation) {
      if (name === "per12HoursCharge") {
        return {
          per12HoursCharge: num,
          perHourCharge: round(num / 12),
        };
      }

      if (name === "perHourCharge") {
        return {
          perHourCharge: num,
          per12HoursCharge: round(num * 12),
        };
      }

      return null;
    }

    //  INCITY + MINI LOGIC (unchanged)
    if (name === "perMinuteCharge") {
      return {
        perMinuteCharge: num,
        perHalfHourCharge: round(num * 30),
        perHourCharge: round(num * 60),
      };
    }

    if (name === "perHalfHourCharge") {
      const perMinute = num / 30;
      return {
        perMinuteCharge: round(perMinute),
        perHalfHourCharge: num,
        perHourCharge: round(perMinute * 60),
      };
    }

    if (name === "perHourCharge") {
      const perMinute = num / 60;
      return {
        perMinuteCharge: round(perMinute),
        perHalfHourCharge: round(perMinute * 30),
        perHourCharge: num,
      };
    }

    return null;
  };

  const handleFareChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const calculated = calculateTimeFares(name, value);

      return {
        ...prev,
        fares: calculated
          ? { ...prev.fares, ...calculated }
          : { ...prev.fares, [name]: Number(value) },
      };
    });
  };

  const handleUpdateFare = async () => {
    try {
      setIsUpdating(true);

      //  FIXED HERE ALSO
      const isOutstation = formData.tripSection === "outstation";

      const response = await fetch(
        `${config.backEndBaseUrl}fare/updateFare/${fare.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
          },
          body: JSON.stringify({
            country: formData.country || "India",
            state: formData.state || "west bengal",
            city: formData.city,
            vehicleType: formData.vehicleType,
            tripSection: formData.tripSection,
            gearType: formData.gearType,
            fares: {
              baseCharge: Number(formData.fares.baseCharge),

              ...(isOutstation
                ? {
                    per12HoursCharge: Number(formData.fares.per12HoursCharge),
                    perHourCharge: Number(formData.fares.perHourCharge),
                  }
                : {
                    perMinuteCharge: Number(formData.fares.perMinuteCharge),
                    perHalfHourCharge: Number(formData.fares.perHalfHourCharge),
                    perHourCharge: Number(formData.fares.perHourCharge),
                  }),
            },
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Update failed");
      }

      toast.success("Fare updated successfully");
      onSuccess();
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <div className="custom-modal-header">
          <div className="edit-fare-header-content">
            <h4>Update Fare Configuration</h4>

            <div className="edit-fare-summary">
              <div className="edit-fare-summary-item">
                <span>Trip Section</span>
                <strong>{displayLabel(formData.tripSection)}</strong>
              </div>

              {/* <div className="edit-fare-summary-item">
                <span>Trip Type</span>
                <strong>{displayLabel(formData.tripType)}</strong>
              </div> */}

              <div className="edit-fare-summary-item">
                <span>City</span>
                <strong>{displayLabel(formData.city)}</strong>
              </div>

              <div className="edit-fare-summary-item">
                <span>Vehicle Type</span>
                <strong>{displayLabel(formData.vehicleType)}</strong>
              </div>

              <div className="edit-fare-summary-item">
                <span>Gear Type</span>
                <strong>{displayLabel(formData.gearType)}</strong>
              </div>
            </div>
          </div>

          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="custom-modal-body">
          <div className="form-grid">
            {Object.keys(formData.fares)
              .filter((key) => {
                if (
                  key === "adminCommission" ||
                  key === "adminCommissionType" ||
                  key === "perKmFare"
                )
                  return false;

                //  FIXED FILTER
                if (isOutstation) {
                  return [
                    "baseCharge",
                    "perHourCharge",
                    "per12HoursCharge",
                  ].includes(key);
                }

                return [
                  "baseCharge",
                  "perMinuteCharge",
                  "perHalfHourCharge",
                  "perHourCharge",
                ].includes(key);
              })
              .map((key) => (
                <div className="form-group" key={key}>
                  <label>{formatLabel(key)}</label>
                  <input
                    type="number"
                    name={key}
                    value={formData.fares[key] || ""}
                    onChange={handleFareChange}
                  />
                </div>
              ))}
          </div>
        </div>

        <div className="custom-modal-footer">
          <button className="btn btn-dark" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={handleUpdateFare}
            disabled={isUpdating}
          >
            {isUpdating ? "Updating...." : "Update Fare"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditFareModal;
